export const ListOf_ReferenceTypes = ['snomed', 'loinc', 'book', 'article', 'upToDate', 'icdCode', 'rxCUI', 'atc', 'cpt'];
export const arraySnomedLoinc = ['snomed', 'loinc'];
export const arrayArticleUpToDate = ['article', 'upToDate'];
export const ActionKey_ParseSnomedCSV = 'parse snomed csv';
export const SnomedDictionaryCSVFileName = 'snomed_dictionary.csv';
//# sourceMappingURL=consts.js.map